export default "__VITE_ASSET__B_Dyq55D__"